import { useCallback, useState } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'

export interface City {
  label: string
  value: string
}

interface CityApi {
  id: string
  city_name: string
}

export const useTopCities = () => {
  const [topCities, setTopCities] = useState<City[]>([])

  const getTopCities = useCallback(() => {
    _data
      .get(`${Project.liveApi}analytics/top-cities/`)
      .then((cities: CityApi[]) => {
        const transformedCities = cities
          // the SelectField component nees label and value
          .map((city) => ({ label: city.city_name, value: city.id }))
          .sort((a, b) => a.label.localeCompare(b.label))
        setTopCities(transformedCities)
      })
      .catch((error) => console.error('Error fetching top cities:', error))
  }, []);

  return { topCities, getTopCities }
}